module.exports = __webpack_public_path__ + "assets/e97ba7150eaab1cf76b7d1c6a080206f.svg";